import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import PasswordInput from '../atoms/PasswordInput';

function LoginForm({ onSubmit, loading, error }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit({ email, password });
  }

  return (
    <>
      {error && (
        <Alert variant="danger" className="small py-2 mb-3 text-center" style={{ borderRadius: 12 }}>
          {error}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        <Form.Control
          type="email"
          placeholder="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          inputMode="email"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck="false"
          enterKeyHint="next"
          className="mb-3 auth-input"
        />
        <PasswordInput
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
          enterKeyHint="go"
          className="mb-3"
        />

        <button type="submit" disabled={loading} className="auth-submit">
          {loading ? 'Entrando…' : 'Entrar'}
        </button>
      </Form>
    </>
  );
}

export default LoginForm;
